<template>
  <main class="container">
    <app-quizzes></app-quizzes>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import Quizzes from '@/components/quizzes/Quizzes'
// import l from '@/vendor/logger'

export default {
  name: 'Studio',

  created () {
    this.$store.dispatch('setMode', this.$route.params.mode.toUpperCase())
    this.$store.commit('setRid', this.$route.params.rid)
    this.$store.dispatch('room/bindRoom')
    this.$store.dispatch('quizzes/bindQuizzes')
    this.$store.commit('room/setRoomType', 'STUDIO')
  },

  mounted () {
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  computed: {
    ...mapState([
      'rid'
    ]),
    ...mapState('quizzes', [
      'quizzes'
    ])
  },

  methods: {
    unbind () {
      this.$store.dispatch('quizzes/unbindQuizzes')
      this.$store.dispatch('room/unbindRoom')
    }
  },

  components: {
    'app-quizzes': Quizzes
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
